module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_r-2d414712d27096feb122388f7bf84525.png";